import { Component, OnDestroy, OnInit, Inject, ViewEncapsulation } from '@angular/core';


import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

import { Cuenta } from "app/main/gastos/finanzas/cuenta.model";


@Component({
  selector: 'app-cuenta-form',
  templateUrl: './cuenta-form.component.html',
  styleUrls: ['./cuenta-form.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CuentaFormDialogComponent implements OnInit, OnDestroy {

  categories: any[];
  currencies: any[];

  action: string;
  edit: boolean = false;
  account: Cuenta;
  cuentaForm: FormGroup;
  dialogTitle: string;

  // Private
  // private _unsubscribeAll: Subject<any>;

  constructor(
    public matDialogRef: MatDialogRef<CuentaFormDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private _data: any,
    private _formBuilder: FormBuilder,
  ) {

    // Set the categories
    this.categories = _data.categories;

    // Set the currencies
    this.currencies = _data.currencies;

    // Set the defaults
    this.action = _data.action;

    if (this.action === 'edit') {
      this.dialogTitle = 'Editar Cuenta';
      this.account = _data.account;
      this.edit = true;
    }
    else {
      this.dialogTitle = 'Nueva Cuenta';
      this.account = new Cuenta({});
    }

    this.cuentaForm = this.createCuentaForm();

  }

  ngOnInit() {
    // Subscribe to categories
    // this._finanzasCuentasService.onCategoriesChanged
    //   .pipe(takeUntil(this._unsubscribeAll))
    //   .subscribe(categories => {
    //     console.log('Lista de Categorias ', categories);
    //     this.categories = categories;
    //   });
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    // this._unsubscribeAll.next();
    // this._unsubscribeAll.complete();
  }


  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Create cuenta form
   *
   * @returns {FormGroup}
   */
  createCuentaForm(): FormGroup {
    return this._formBuilder.group({
      id: [this.account.id],
      nombre: [this.account.nombre],
      descripcion: [this.account.descripcion],
      category: [this.account.category],
      currency: [this.account.currency]
    });
  }

}
